module.exports = __webpack_public_path__ + "svg_80x80/tornado.0533b9.svg";